document.addEventListener('DOMContentLoaded', () => {
  const hero = document.querySelector('.hero.slideshow');
  const slides = hero ? Array.from(hero.querySelectorAll('.slide')) : [];
  const dots = hero ? Array.from(hero.querySelectorAll('.slideshow__dots .dot')) : [];

  if (slides.length > 1) {
    let activeIndex = slides.findIndex((slide) => slide.classList.contains('slide--active'));
    if (activeIndex < 0) activeIndex = 0;
    let intervalId;

    const setActive = (index) => {
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('slide--active', slideIndex === index);
      });
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('active', dotIndex === index);
      });
      activeIndex = index;
    };

    const queueNext = () => {
      window.clearInterval(intervalId);
      intervalId = window.setInterval(() => {
        setActive((activeIndex + 1) % slides.length);
      }, 5000);
    };

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        setActive(index);
        queueNext();
      });
    });

    queueNext();
  }

  const animatedSections = document.querySelectorAll('[data-aos]');
  if (animatedSections.length) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.14 }
    );

    animatedSections.forEach((element) => observer.observe(element));
  }

  // Mobile product card image slide on scroll
  // Mobile product card image slide on scroll
  const productCards = document.querySelectorAll('.product-card');
  if (productCards.length) {
    const cardObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // Add is-scrolled when card is near the center of the viewport
          if (entry.isIntersecting) {
            entry.target.classList.add('is-scrolled');
          } else {
            // Optional: remove class when it leaves the center to reset it
            entry.target.classList.remove('is-scrolled');
          }
        });
      },
      { 
        // Trigger when the element crosses the middle 70% of the screen
        rootMargin: '-15% 0px -15% 0px',
        threshold: 0 
      }
    );

    productCards.forEach((card) => cardObserver.observe(card));
  }
});
